import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { SwapHoriz } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const SwitchFlowNode = memo(({ id, data, isConnectable, selected }) => {
  const flowName =
    data?.flowName ||
    data?.flow?.name ||
    data?.typebotIntegration?.message ||
    null;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<SwapHoriz />}
      title="Trocar Fluxo"
      color="#EC5858"
      bgColor="#FEFAFA"
      isConnectable={isConnectable}
      selected={selected}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 10px",
          borderRadius: 20,
          fontSize: 11,
          fontWeight: 600,
          backgroundColor: flowName ? "#FDECEC" : "#f5f5f5",
          color: flowName ? "#EC5858" : "#999",
          border: `1px solid ${flowName ? "#EC585830" : "#e0e0e0"}`,
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <SwapHoriz style={{ fontSize: 14, color: flowName ? "#EC5858" : "#bbb" }} />
        {flowName || "Selecione um fluxo"}
      </div>
    </NodeWrapper>
  );
});

SwitchFlowNode.displayName = "SwitchFlowNode";
export default SwitchFlowNode;
